import { Position, Toaster } from "@blueprintjs/core";

export const AppToaster = Toaster.create({
  className: "recipe-toaster sticky-toastr",
  position: Position.TOP
});
